module.exports = __webpack_public_path__ + "img/map3.d6c376b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/loading/imgs/map3.png
// module id = ./assets/loading/imgs/map3.png
// module chunks = 2 3 4 5 6 7 8